import styled, { css } from 'styled-components';

export const StyledContainer = styled.div`
    padding: 16px;
    text-align: left;
`;

export const StyledInfoWrapper = styled.div<{ error?: boolean }>`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    ${({ error, theme }) =>
        error &&
        css`
            color: ${theme.colors.error};
        `}
`;

export const StyledLabel = styled.span`
    font-size: ${({ theme }) => theme.fontSize.verySmall};
`;

export const StyledValue = styled.span<{ transparent?: boolean }>`
    font-weight: bold;
    opacity: ${({ transparent }) => (transparent ? 0.5 : 1)};
`;

export const StyledLoaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
